import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { ProfileHttp } from '../../../tsScripts/providers/http/ProfileHttp';
import { ErrorDTO } from '../../../tsScripts/DTO/ErrorDTO';
import { MessageStorage } from '../../../tsScripts/util/MessageStorage';

@Component({
    selector: 'modal-delete-my-profile-photo',
    templateUrl: "../../../views/components/myProfile/modalDeleteUserProfilePhoto.html",
    providers: [],
    styleUrls: ["../../../styles/agent.css"]
})

export class ModalDeleteUserProfilePhoto implements OnInit {

    loading: boolean;
    error: boolean;
    errorMessage: string;

    constructor(private ProfileHttp: ProfileHttp,
                private activeModal: NgbActiveModal) {
        this.loading = false;
        this.error = false;
    }

    cancel() {
        this.activeModal.close();
    }

    deleteProfilePhoto() {
        this.loading = true;
        this.ProfileHttp.deleteProfileImage({}).then((response: any) => {
            this.loading = false;
            MessageStorage.add("success", "Foto removida con éxito");
            this.activeModal.dismiss();
        }, (error: ErrorDTO) => {
            this.loading = false;
            this.error = true;
            this.errorMessage = error.errorMessage;
        });
    }

    ngOnInit() {
    }
}